import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import TransactionLaw from '@/views/pages/TransactionLaw.vue';
import Usage from '@/views/pages/Usage.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/pages/transactionLaw',
    name: 'TransactionLaw',
    component: TransactionLaw,
  },
  {
    path: '/pages/usage',
    name: 'Usage',
    component: Usage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // ページ遷移時にトップへスクロール
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
